module.exports = __webpack_public_path__ + "assets/9f369fd32ed12e8183293670a3102555.png";